/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchAndSavePreviewImagesForStopRequest
 */
export interface SearchAndSavePreviewImagesForStopRequest {
    /**
     * Location query to search images for
     * @type {string}
     * @memberof SearchAndSavePreviewImagesForStopRequest
     */
    locationQuery: string;
    /**
     * Number of images to search and save (default: 5, max: 20)
     * @type {number}
     * @memberof SearchAndSavePreviewImagesForStopRequest
     */
    count?: number;
}

/**
 * Check if a given object implements the SearchAndSavePreviewImagesForStopRequest interface.
 */
export function instanceOfSearchAndSavePreviewImagesForStopRequest(value: object): value is SearchAndSavePreviewImagesForStopRequest {
    if (!('locationQuery' in value) || value['locationQuery'] === undefined) return false;
    return true;
}

export function SearchAndSavePreviewImagesForStopRequestFromJSON(json: any): SearchAndSavePreviewImagesForStopRequest {
    return SearchAndSavePreviewImagesForStopRequestFromJSONTyped(json, false);
}

export function SearchAndSavePreviewImagesForStopRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAndSavePreviewImagesForStopRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'locationQuery': json['locationQuery'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

  export function SearchAndSavePreviewImagesForStopRequestToJSON(json: any): SearchAndSavePreviewImagesForStopRequest {
      return SearchAndSavePreviewImagesForStopRequestToJSONTyped(json, false);
  }

  export function SearchAndSavePreviewImagesForStopRequestToJSONTyped(value?: SearchAndSavePreviewImagesForStopRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationQuery': value['locationQuery'],
        'count': value['count'],
    };
}

